import {AfterViewInit, Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges} from '@angular/core';

@Directive({
  selector: '[off]',
  standalone: true,
})
export class HeroOffDirective implements AfterViewInit, OnChanges {

  // when the attibute is just set without value
  // it will be an empty string
  @Input() off: boolean | string | null = true;

  constructor(private el: ElementRef, private renderer: Renderer2) {
  }

  ngOnChanges(): void {
    this._setState()
  }

  ngAfterViewInit(): void {
    this._setState()
  }

  /**
   * Set the off state of the element
   */
  private _setState() {
    const isOff = this.off === true || this.off === 'true' || this.off === '';

    const element = this.el.nativeElement;
    const elementName = element.tagName.toLowerCase();

    switch (elementName) {
      case 'a': {
        const className = 'disabled';
        isOff
          ? this.renderer.addClass(element, className)
          : this.renderer.removeClass(element, className);

      }
        break;
    }
  }

}
